import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/footer.css";
import facebook from "../images/footer/facebook.png";
import linkedin from "../images/footer/linkedin.png";

function Footer() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div className="footerContainer">
      <div className="footerImage">
        <img
          className="Logo"
          src="/HiALogoWhite.png"
          alt="Healthcare interAction Logo"
        />
      </div>
      <div className="footerContent">
        <div className="footerLeftColumn">
          <ul className="footerLinks">
            <li>
              <NavLink to="/howWeCanHelp" onClick={scrollToTop}>
                Transform Your Teams
              </NavLink>
            </li>
            <li>
              <NavLink to="/articles" onClick={scrollToTop}>
                Coffee Break Articles
              </NavLink>
            </li>
            <li>
              <NavLink to="/sustainability" onClick={scrollToTop}>
                Sustainability
              </NavLink>
            </li>
            <li>
              <NavLink to="/team" onClick={scrollToTop}>
                Our Team
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact" onClick={scrollToTop}>
                Contact Us
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="footerMiddleColumn">
          <h3>Follow Us</h3>
          <div className="socialMediaIcons">
            {/*             <a
              href="https://www.facebook.com/healthcareinteraction"
              target="_blank"
              rel="noreferrer"
            >
              <img src={facebook} alt="facebook icon" />
            </a> */}
            <a
              href="https://www.linkedin.com/company/healthcare-interaction-limited"
              target="_blank"
              rel="noreferrer"
            >
              <img src={linkedin} alt="linkedin icon" />
            </a>
          </div>
        </div>
        <div className="footerRightColumn">
          <h3>Get Our Latest News</h3>
          <form className="subscribeForm">
            <input
              id="subscribe-form"
              type="text"
              placeholder="Email address"
            ></input>
            <button type="submit">Subscribe</button>
          </form>
        </div>
      </div>
      <div className="footerBottom">
        <ul className="footerBottomLinks">
          <li>
            <NavLink to="/privacyPolicy">Privacy Policy</NavLink>
          </li>
          <li>|</li>
          <li>
            <NavLink to="/cookies">Cookies</NavLink>
          </li>
        </ul>
        <p>
          &copy; Copyright 2024 Healthcare interAction. All Rights Reserved.
        </p>
      </div>
    </div>
  );
}

export default Footer;
